import React, { useState } from 'react'
import {
  Box,
  Divider,
  FormControl,
  MenuItem,
  Popover,
  Select,
  Tooltip,
} from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import EditIcon from '@mui/icons-material/Edit'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import MotorDialog from 'src/components/BuyPolicy/insuranceScreens/motor/MotorDialog'
import { Button } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import IDVCoverTile from 'src/components/BuyPolicy/insuranceScreens/motor/VehicleDetailsTiles/IDVCoverTile'
import {
  MOTOR_NCB_CLIAM,
  MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS,
  ncbTooltip,
  ncbValueObjectList,
  POLICY_TYPE_MOTOR,
} from 'src/utils/constants/BuyPolicyMotor'
import { updatePreviousPolicyDetailsMotor } from 'src/actions'
import PolicyExpireDetailsTile from 'src/components/BuyPolicy/insuranceScreens/motor/VehicleDetailsTiles/PolicyExpireDetailsTile'
import infoToolTip from 'src/assets/Buy_Policy_Images/infoToolTip.svg'
import motorFourWheeler from 'src/assets/Buy_Policy_Images/motorFourWheeler.svg'
import formatToINR from 'src/utils/commonMethods/formatToINR'
import { formatDateMonth } from 'src/utils/commonMethods/formatDate'
import { NO, YES } from 'src/utils/constants/BuyPolicy'

const VehicleDetails = ({ isEdit }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const motorDetails = useSelector((state) => state?.buyPolicyMotorReducer)
  const vehicleDetails = motorDetails?.vehicleDetails
  const previousPolicyDetails = motorDetails?.previousPolicyDetails
  const currentPolicyDetails = motorDetails?.currentPolicyDetails
  const [popoverElement, setPopoverElement] = useState('')
  const isVehicleDetailsFetched = useSelector(
    (state) => state?.buyPolicyMotorReducer?.isVehicleDetailsFetched
  )

  const [anchorElEditPopover, setAnchorElEditPopover] = React.useState(null)
  const openEditPopover = Boolean(anchorElEditPopover)
  const idEditPopover = openEditPopover ? 'simple-popover-edit' : undefined
  const ncbValue =
    previousPolicyDetails?.existingPolicyClaim === NO ? false : true
  const [previousPolicyClaim, setPreviousPolicyClaim] = useState(ncbValue)

  const handleClickEditPopover = (event) => {
    setAnchorElEditPopover(event?.currentTarget)
  }

  const handleCloseEditPopover = () => {
    setAnchorElEditPopover(null)
  }

  const handleNcbClaim = (ncbClaimLastYear) => {
    if (ncbClaimLastYear === YES) {
      setPreviousPolicyClaim(true)
    } else {
      setPreviousPolicyClaim(false)
    }
    dispatch(
      updatePreviousPolicyDetailsMotor({
        ...previousPolicyDetails,
        existingPolicyClaim: ncbClaimLastYear,
        ncb: ncbClaimLastYear === YES ? 0 : previousPolicyDetails?.ncb,
      })
    )
  }
  const handleEditPopoverClick = (event, element) => {
    setPopoverElement(element)
    handleClickEditPopover(event)
  }

  const getEditPopoverComponent = () => {
    switch (true) {
      case MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS?.EDIT_POLICY_EXPIRY_DETAILS ===
        popoverElement:
        return (
          <>
            <Box>
              <PolicyExpireDetailsTile
                handleCloseEditPopover={handleCloseEditPopover}
              />
            </Box>
          </>
        )
      case MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS?.EDIT_IDV === popoverElement:
        return (
          <>
            <Box>
              <IDVCoverTile />
            </Box>
          </>
        )
      default:
        return
    }
  }

  return (
    <Box className={classes.container}>
      {open ? <MotorDialog open={open} setOpen={setOpen} /> : null}

      <Popover
        id={idEditPopover}
        open={openEditPopover}
        anchorEl={anchorElEditPopover}
        onClose={handleCloseEditPopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        className={classes.vehicleDetailsPopover}
      >
        <Box>{getEditPopoverComponent()}</Box>
      </Popover>
      <Box>
        <Box className={classes.vehicleCard}>
          <Box>
            <img
              src={
                motorDetails?.vehicleDetails?.vehicleLogo
                  ? motorDetails?.vehicleDetails?.vehicleLogo
                  : motorFourWheeler
              }
              alt={'brand-logo'}
              className={classes.brandLogo}
            />
          </Box>
          <Box className={classes.vehicleCardMain}>
            <Box className={classes.vehicleCardTitle}>
              <Box className={classes.buttonBox}>
                <Box>
                  <Box className={classes.vehicleBrandText}>
                    {motorDetails?.vehicleDetails?.brand?.genericName}
                  </Box>
                  <Box className={classes.vehicleModelText}>
                    {`${motorDetails?.vehicleDetails?.model?.modelGenericName}${
                      motorDetails?.vehicleDetails?.variant
                        ?.genericVariantName || ''
                    }`}
                  </Box>
                </Box>

                {!isVehicleDetailsFetched ? (
                  <Box>
                    {isEdit ? (
                      <Button
                        variant='outlined'
                        size='small'
                        className={classes.editButton}
                        startIcon={<EditIcon className={classes.buttonIcon} />}
                        onClick={() => setOpen(true)}
                      >
                        Edit
                      </Button>
                    ) : null}
                  </Box>
                ) : null}
              </Box>
            </Box>
            <Box className={classes.vehicleCardInfo}>
              <Box className={classes.vehicleCardTextThree}>
                {formatDateMonth(motorDetails?.vehicleDetails?.regDate)}
              </Box>
              <Box className={classes.vehicleCardTextThree}>
                {motorDetails?.vehicleDetails?.fuelType?.genericName}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider orientation='vertical' variant='middle' flexItem />

      {isEdit ? (
        <>
          <Box className={classes.sectionColumn}>
            <Box className={classes.sectionHeading}>Policy Expire Details</Box>
            <Box className={classes.sectionData}>
              <Box className={classes.sectionRow}>
                <Box>
                  {formatDateMonth(
                    motorDetails?.previousPolicyDetails?.expiredDate
                  ) ||
                    formatDateMonth(
                      motorDetails?.previousPolicyDetails?.expiryDate
                    )}
                </Box>
                <EditIcon
                  fontSize='small'
                  className={classes.editIcon}
                  onClick={(e) =>
                    handleEditPopoverClick(
                      e,
                      MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS?.EDIT_POLICY_EXPIRY_DETAILS
                    )
                  }
                />
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <>
          <Box className={classes.sectionPolicydetails}>
            <Box className={classes.sectionPolicyActions}>
              <span className={classes.sectionPolicyKeys}>Coverage Type:</span>
              <span className={classes.sectionPolicyKeys}>Reg. Number:</span>
              <span className={classes.sectionPolicyKeys}>IDV:</span>
            </Box>
            <Box className={classes.sectionPolicyActions}>
              <span className={classes.sectionPolicyValues}>
                {POLICY_TYPE_MOTOR[currentPolicyDetails?.policyType]}
              </span>
              <span className={classes.sectionPolicyValues}>
                {' '}
                {vehicleDetails?.vehicleNumber}
              </span>
              <span className={classes.sectionPolicyValues}>
                {' '}
                {formatToINR(motorDetails?.selectedQuote?.idvCover) ?? '-'}
              </span>
            </Box>
          </Box>
        </>
      )}

      <Divider orientation='vertical' variant='middle' flexItem />
      {isEdit ? (
        <>
          <Box className={classes.sectionColumn}>
            <Box className={classes.sectionHeading}>Any claims last year?</Box>
            <Box className={classes.sectionData}>
              <Box className={classes.sectionRow}>
                <Box>
                  <Box className={classes.switchContainer}>
                    <Box className={classes.switchContainerMain}>
                      <Box
                        className={`${classes.claimsCategoryContainer} ${
                          previousPolicyDetails?.existingPolicyClaim ===
                          MOTOR_NCB_CLIAM?.YES
                            ? classes.selected
                            : classes.notSelected
                        }`}
                        onClick={() => handleNcbClaim(MOTOR_NCB_CLIAM?.YES)}
                        id='ncb-cliam-yes'
                      >
                        <Box className={classes.ncbClaimYesText}>Yes</Box>
                      </Box>
                      <Box
                        className={`${classes.claimsCategoryContainer} ${
                          previousPolicyDetails?.existingPolicyClaim ===
                          MOTOR_NCB_CLIAM?.NO
                            ? classes.selected
                            : classes.notSelected
                        }`}
                        onClick={() => handleNcbClaim(MOTOR_NCB_CLIAM?.NO)}
                        id='ncb-cliam-no'
                      >
                        <Box className={classes.ncbClaimNoText}>No </Box>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </>
      ) : (
        <Box className={classes.contactSection}>
          <Box className={classes.contactType}>
            <span className={classes.sectionPolicyKeys}>Mobile:</span>
            <span className={classes.sectionPolicyValues}>
              {motorDetails?.personalDetails?.mobileNumber}
            </span>
          </Box>
          <Box className={classes.contactType}>
            <span className={classes.sectionPolicyKeys}>Email:</span>
            <span className={classes.sectionPolicyValues}>
              {motorDetails?.personalDetails?.email}
            </span>
          </Box>
        </Box>
      )}
      <Divider orientation='vertical' variant='middle' flexItem />
      {isEdit ? (
        <>
          <Box className={classes.sectionColumn}>
            <Box className={classes.ncbHeading}>
              <Box className={classes.sectionHeading}>No Claim Bonus (NCB)</Box>
              <Box>
                <Tooltip
                  arrow
                  title={
                    <>
                      <Box>{ncbTooltip?.ncbOne}</Box>
                      <Box>{ncbTooltip?.ncbTwo}</Box>
                    </>
                  }
                >
                  <img src={infoToolTip} className={classes.infoImage} />
                </Tooltip>
              </Box>
            </Box>

            <Box className={classes.sectionData}>
              <Box className={classes.sectionRow}>
                <Box>
                  <FormControl>
                    {!previousPolicyClaim ? (
                      <Select
                        id='ncbValue'
                        name='ncbValue'
                        className={classes.inputTextField}
                        value={previousPolicyDetails?.ncb}
                        onChange={(e) =>
                          dispatch(
                            updatePreviousPolicyDetailsMotor({
                              ...previousPolicyDetails,
                              ncb: e?.target?.value,
                            })
                          )
                        }
                        size='small'
                      >
                        {ncbValueObjectList?.map((item) => {
                          return (
                            <MenuItem
                              value={item?.value}
                              key={item?.value}
                              // className={'default-menu-item'}
                            >
                              {item?.option}
                            </MenuItem>
                          )
                        })}
                      </Select>
                    ) : (
                      <div>0%</div>
                    )}
                  </FormControl>
                </Box>
              </Box>
            </Box>
          </Box>
          <Divider orientation='vertical' variant='middle' flexItem />
          <Box className={classes.sectionColumn}>
            <Box className={classes.sectionHeading}>
              IDV Cover (Insured Value)
            </Box>
            <Box className={classes.sectionData}>
              <Box className={classes.sectionRow}>
                <Box>
                  {formatToINR(
                    motorDetails?.currentPolicyDetails?.idv
                      ? motorDetails?.currentPolicyDetails?.idv
                      : motorDetails?.currentPolicyDetails?.idvMaxValue
                  )}
                </Box>
                <ExpandMoreIcon
                  fontSize='small'
                  className={classes.editIcon}
                  onClick={(e) =>
                    handleEditPopoverClick(
                      e,
                      MOTOR_VEHICLE_DETAILS_POPOVER_ELEMENTS?.EDIT_IDV
                    )
                  }
                />
              </Box>
              <Box className={classes.recommendedIDV}>Recommended IDV</Box>
            </Box>
          </Box>
        </>
      ) : (
        <Box className={classes.policyProvider}>
          <Box className={classes.policyProviderContent}>
            Previous Policy Provider & Expiry Date
          </Box>
          <Box className={classes.policyActions}>
            <img
              src={motorDetails?.previousPolicyDetails?.previousProviderLogo}
              alt={
                motorDetails?.previousPolicyDetails?.previousPolicyProvider
                  ?.insuranceCompanyName
              }
            />
            <span className={classes.relianceContent}>
              (
              {formatDateMonth(
                motorDetails?.previousPolicyDetails?.expiredDate
              ) ||
                formatDateMonth(
                  motorDetails?.previousPolicyDetails?.expiryDate
                )}
              )
            </span>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default VehicleDetails

const useStyles = makeStyles({
  container: {
    border: '1px solid #BED2D8',
    borderRadius: 10,
    display: 'flex',
    flexDirection: 'row',
    background: 'linear-gradient(271.38deg, #4DC3E3 -239.49%, #FFFFFF 51.17%)',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    '@media (max-width: 768px)': {
      flexDirection: 'column',
      padding: 20,
    },
    padding: '13px 33px',
  },
  vehicleCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  vehicleCardMain: {
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    gap: 9,
  },
  vehicleCardTitle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  vehicleCardInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    gap: 17,
    marginRight: 'auto',
  },

  vehicleBrandText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '13px',
    letterSpacing: '0em',
    // textAlign: 'center',
    color: '#9D9D9D',
  },
  vehicleModelText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  vehicleCardTextThree: {
    fontFamily: 'Roboto',
    fontSize: '13px',
    fontWeight: 600,
    lineHeight: '15px',
    letterSpacing: '0em',
    textAlign: 'center',
  },
  editButton: {
    border: '1px solid #E4E4E4',
    width: 60,
    height: 27,
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '14.06px',
    color: '#2BACCF !important',
    textTransform: 'capitalize',
    padding: '10px 20px',
  },
  sectionColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 5,
    padding: 10,
  },
  sectionHeading: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#939393',
    // textAlign: 'left',
  },
  sectionData: {
    fontFamily: 'Roboto',
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '19px',
    letterSpacing: '0em',
    marginRight: 'auto',
  },
  recommendedIDV: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16px',
    letterSpacing: '0em',
    color: '#939393',
  },
  sectionRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 10,
  },
  editIcon: {
    color: '#2BACCF',
    cursor: 'pointer',
  },
  sectionPolicyKeys: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
    color: '#939393',
  },
  sectionPolicyValues: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '16.41px',
  },
  relianceContent: {
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 500,
    color: '#A12424',
  },
  policyProviderContent: {
    color: '#565656',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 400,
  },
  sectionPolicydetails: {
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    padding: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  sectionPolicyActions: {
    display: 'flex',
    flexDirection: 'column',
    gap: '5px',
  },
  policyProvider: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
  },
  policyActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '5px',
  },
  buttonIcon: {
    marginRight: '-5px',
    fontSize: '11px',
    marginBottom: '5px',
  },
  sectionText: {
    color: '#939393',
  },
  buttonBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 20,
  },
  brandLogo: {
    height: '40px',
    width: '40px',
  },
  vehicleDetailsPopover: {
    boxShadow: '0px 0px 15px 0px #00000066',
  },
  switchContainer: {
    border: '1px solid #C1C1C1',
    backgroundColor: '#FFFFFF',
    borderRadius: 5,
    maxWidth: '97px',
  },
  switchContainerMain: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '3px',
    padding: '4px',
  },

  claimsCategoryContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    padding: '0px 10px 0px 10px',
    cursor: 'pointer',
    height: '20px',
    color: '#2BA6C8',
  },

  ncbClaimYesText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
  },
  ncbClaimNoText: {
    fontFamily: 'Roboto',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '16.41px',
  },
  selected: {
    background: '#29BDE4',
    borderRadius: 3,
    color: '#FFFFFF',
  },
  notSelected: {
    color: '#A4A4A4',
  },
  inputTextField: {
    borderRadius: '5px !important',
    backgroundColor: 'white !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    minWidth: 60,
  },
  ncbHeading: { display: 'flex', flexDirection: 'row' },
  infoImage: {
    width: '15px',
    height: '15px',
    paddingLeft: '3px',
    marginTop: '-10px',
  },
  contactSection: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'left',
  },
  contactType: { display: 'flex', flexDirection: 'row', gap: 5 },
})
